import ScrollableArea from "components/ScrollableArea"
import { graphql, useStaticQuery } from "gatsby"

import Card from "./Card"

export default function Testimonials({
	backgroundColor,
	sidePadding,
}: {
	backgroundColor: string
	sidePadding?: number
}) {
	const TestimonialsRaw: Queries.TestimonialsQuery = useStaticQuery(graphql`
		query Testimonials {
			allTestimonialsJson {
				edges {
					node {
						id
						company
						logo {
							childImageSharp {
								gatsbyImageData(width: 50)
							}
						}
						photo {
							childImageSharp {
								gatsbyImageData(width: 300)
							}
						}
						review
						name
						role
					}
				}
			}
		}
	`)

	const testimonials = TestimonialsRaw.allTestimonialsJson.edges.map(
		(e) => e.node,
	)

	return (
		<ScrollableArea sidePadding={sidePadding}>
			{testimonials.map((item) => (
				<Card key={item.id} item={item} backgroundColor={backgroundColor} />
			))}
		</ScrollableArea>
	)
}
